let newIn =
[{
    imgUrl: "NewIn1.jpg",
    imgUrl2: "NewIn1_1.jpg",
    title: "말본 클러치 백 BLACK",
    code: "M3343PBG50BLK",
    price: "199,000원"

},{
    imgUrl: "NewIn2.jpg",
    imgUrl2: "NewIn2_2.jpg",
    title: "여름 리버스 버킷 햇 IVORY",
    code: "M3343PCP61IVY",
    price: "159,000원"

},{
    imgUrl: "NewIn3.jpg",
    imgUrl2: "NewIn3_3.jpg",
    title: "하이게이지 슬리브리스 GREEN (WOMAN)",
    code: "M3322PSL51GRN",
    price: "259,000원"
    

},{
    imgUrl: "NewIn4.jpg",
    imgUrl2: "NewIn4_4.jpg",
    title: "여름 스트라이프 숏팬츠 GREEN (MAN)",
    code: "M3321PHP43GRN",
    price: "319,000원"

},{
    imgUrl: "NewIn5.jpg",
    imgUrl2: "NewIn5_5.jpg",
    title: "여름 니트 베스트 LEMON (WOMAN)",
    code: "M3322PKV52LEM",
    price: "319,000원"

},{
    imgUrl: "NewIn6.jpg",
    imgUrl2: "NewIn6_6.jpg",
    title: "스트라이프 스웨터 버튼업 KHAKI (MAN)",
    code: "M3321PTS41KHK",
    price: "399,000원"

},{
    imgUrl: "NewIn7.jpg",
    imgUrl2: "NewIn7_7.jpg",
    title: "플레이어 숏팬츠 LIGHT BLUE (MAN)",
    code: "M3321PHP08LBL",
    price: "279,000원"

},{
    imgUrl: "NewIn8.jpg",
    imgUrl2: "NewIn8_8.jpg",
    title: "스트라이프 스웨터 숏팬츠 BEIGE (MAN)",
    code: "M3321PHP41BEI",
    price: "299,000원"

},{
    imgUrl: "NewIn9.jpg",
    imgUrl2: "NewIn9_9.jpg",
    title: "피케 카라 슬리브리스 GREEN (WOMAN)",
    code: "M3322PSL52GRN",
    price: "259,000원"

},{
    imgUrl: "NewIn10.jpg",
    imgUrl2: "NewIn10_10.jpg",
    title: "UV 차단 와이드 테리 바이저 IVORY (WOMAN)",
    code: "M3242PVS32IVY",
    price: "109,000원"

}]

export default newIn; 